import {useQuery} from "@tanstack/react-query";
import {downloadFile} from "../services/MediaService";

export const useMediaStore = (uuid) => {
    return useQuery({
        queryKey: ['media-store', uuid],
        queryFn: () => downloadFile(uuid).then((response) => response.data),
        enabled: !!uuid
    })
}